namespace GeniuzPOS.PosShift {
    export class ReportSaleTaxTreeTaxColumns {
        static columnsKey = 'PosShift.ReportSaleTaxTreeTax';
    }
}
